/**
 * ============================================================================
 * DO NOT CHANGE — ACS seat-math clone
 * ============================================================================
 * Source of truth:  acs/src/mapping.js
 *   getRowOrder, isRowInRegion, interpolate2, calculatePanTilt
 *
 * Dashboard Mapping + Crowd Count SRS MUST call these helpers so pan/tilt
 * matches ACS getPTZA. Do not “clean up”, rewrite, or reimplement lerp here.
 *
 * Only update this file when ACS changes the originals — then copy those
 * edits verbatim and keep outputs bit-identical.
 *
 * NOT included: API spreadsheets interpolate2d (intentionally rounds).
 * ============================================================================
 */

let rowDict;

const setRowDict = (dict) => {
  rowDict = dict;
};

const getRowDict = () => rowDict;

/** @deprecated Test alias — prefer setRowDict. */
const _setRowDictForTesting = setRowDict;

const getRowOrder = (row) => (rowDict[row.toLowerCase()] !== undefined
  ? rowDict[row.toLowerCase()]
  : rowDict[row.toUpperCase()]);

const isRowInRegion = (row, region) => {
  const rowOrder = getRowOrder(row);

  if (rowOrder === undefined) {
    return false;
  }

  const minRowOrder = getRowOrder(region[2].row);
  const maxRowOrder = getRowOrder(region[0].row);
  const minRowVal = Math.min(minRowOrder, maxRowOrder);
  const maxRowVal = Math.max(minRowOrder, maxRowOrder);

  return rowOrder >= minRowVal && rowOrder <= maxRowVal;
};

// this would return 0 if pan or tilt is null!!
const interpolate2 = (x0, y0, x1, y1, x2) => {
  // console.log(`x0: ${x0}, y0: ${y0}, x1: ${x1}, y1: ${y1}, x2: ${x2}`)
  let y2;
  if (x0 === x1) y2 = 0.5 * (y0 + y1);
  else y2 = y0 + (parseFloat((y1 - y0) * ((x2 - x0) / (x1 - x0))));

  // console.log('******* x0', x0, 'y0', y0, 'x1', x1, 'y1', y1, 'x2', x2, 'y2', y2, '*********');
  return y2;
};

const calculatePanTilt = (row, seat, region) => {
  const p1 = interpolate2(region[0].seat, region[0].pan, region[1].seat, region[1].pan, seat);
  const p2 = interpolate2(region[2].seat, region[2].pan, region[3].seat, region[3].pan, seat);
  // eslint-disable-next-line max-len
  const p = interpolate2(getRowOrder(region[0].row), p1, getRowOrder(region[2].row), p2, getRowOrder(row));
  // eslint-disable-next-line max-len
  const t1 = interpolate2(getRowOrder(region[0].row), region[0].tilt, getRowOrder(region[2].row), region[2].tilt, getRowOrder(row));
  // eslint-disable-next-line max-len
  const t2 = interpolate2(getRowOrder(region[1].row), region[1].tilt, getRowOrder(region[3].row), region[3].tilt, getRowOrder(row));
  const t = interpolate2(region[0].seat, t1, region[1].seat, t2, seat);

  return {
    pan: p,
    tilt: t,
  };
};

export {
  setRowDict,
  getRowDict,
  _setRowDictForTesting,
  getRowOrder,
  isRowInRegion,
  interpolate2,
  calculatePanTilt,
};

export default {
  setRowDict,
  getRowDict,
  _setRowDictForTesting,
  getRowOrder,
  isRowInRegion,
  interpolate2,
  calculatePanTilt,
};
